import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ConfirmDialogData} from './confirm-dialog-data';

@Component({
  selector: 'xp-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: [
    '../../../shared/components/dialog.common.scss',
    './confirm-dialog.component.scss',
  ],
})
export class ConfirmDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: ConfirmDialogData,
  ) {
  }

}
